const AnalyticsCollector = require('./src/analytics-collector');
module.exports = new AnalyticsCollector['default']();
